<template>
    <div class="event-list">
        <!-- <div v-for="event in filtered_events" :key="event.id">{{event}}</div> -->
        <event-preview v-for="event in events" 
                       :key="('event' + event.id) + '-' + (event.video?('video-' + event.video.id):'')"
                       :event-key="('event' + event.id) + '-' + (event.video?('video-' + event.video.id):'')"
                       :event-id="event.id"
                       :video-id="event.video && event.video.id"
                       :event="event"
                       :showStatus="true"
                       :showEdit="$hisport.options.platform.CONFIGURATION.ENABLE_EVENT_QUICKEDIT"/>
        <div class="event dummy" 
             v-for="x in dummy_events" 
             :key="x.id"
             :style="{width: x.w + 'px', height: x.h + 'px'}">
        </div>
      </div>
</template>
<script>
import { HELPERS }  from 'morpheos.hisport.vueplugin';
import eventPreview from "../_components/event_preview"
export default {
    props: {
        events: {
            type: Array,
            default: function(){ return []; }
        }
    },
    beforeDestroy(){
        window.removeEventListener('resize', this.handleResize);
    },
    mounted(){
        var self = this;
        setTimeout(function(){
            self.dummy_events = HELPERS.dummyList(self.events.length,'.event-item','.event-list');
        },50)
        window.addEventListener('resize', this.handleResize);
    },
    methods:{
        handleResize(){
            self.dummy_events = HELPERS.dummyList(self.events.length,'.event-item','.event-list');
        }
    },
    data(){
        return {
            dummy_events: []
        }
    },
    components: {
        eventPreview
    }
}
</script>
<style scoped>
.event-list{
   display:flex;
   flex-wrap: wrap;
   justify-content: space-between;
   width: calc(100% - 30px);
}
</style>